import { Navigate } from 'react-router-dom';

import { useProfile } from 'context/profile';
import useDefaultRedirect from 'hooks/useDefaultRedirect';
import { Accessor } from 'models/Profile';

type ProtectedRouteProps = {
  children: React.ReactNode;
  accessor?: Accessor | Accessor[];
  strictMode?: boolean;
  deny?: boolean;
  flag?: string | string[];
};

const ProtectedRoute = ({ children, accessor, strictMode = true, deny = false, flag }: ProtectedRouteProps) => {
  const { profile } = useProfile();

  const redirectTo = useDefaultRedirect();

  if (deny) {
    return <Navigate to={redirectTo} replace />;
  }

  if (flag) {
    const flags = Array.isArray(flag) ? flag : [flag];
    if (!flags.every((f) => profile.hasFlag(f))) {
      return <Navigate to={redirectTo} replace />;
    }
  }

  if (accessor) {
    const accessors = Array.isArray(accessor) ? accessor : [accessor];
    const isAccessGranted = strictMode ? profile.hasAll(accessors) : profile?.hasAny(accessors);

    if (!isAccessGranted) {
      return <Navigate to={redirectTo} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
